import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import {
    PADDING_LEFT_RIGHT_SECTION,
    PADDING_TOP_CAPTION,
    PADDING_TOP_CAPTION_MOBILE,
} from '../pagebuilder.style';

export const TagMainCaptionContainer: StyleRule = ({ theme }) => ({
    '& > div': {
        marginTop: pxToRem(PADDING_TOP_CAPTION_MOBILE),
        width: '100%',
        fontSize: pxToRem(12),
        lineHeight: '125%',
    },

    [theme.screen.laptop]: {
        '& > div': {
            marginTop: pxToRem(PADDING_TOP_CAPTION),
            paddingLeft: pxToRem(PADDING_LEFT_RIGHT_SECTION),
            width: '100%',
            fontSize: pxToRem(16),
            lineHeight: '150%',
            overflowWrap: 'break-word',
        },
    },
});

export const TagSubCaptionContainer: StyleRule = ({ theme }) => ({
    '& > div': {
        marginTop: pxToRem(PADDING_TOP_CAPTION_MOBILE),
        width: '100%',
        fontSize: pxToRem(12),
        lineHeight: '125%',
    },

    [theme.screen.laptop]: {
        '& > div': {
            marginTop: pxToRem(PADDING_TOP_CAPTION),
            width: '100%',
            fontSize: pxToRem(16),
            lineHeight: '150%',
            overflowWrap: 'break-word',
        },
    },
});
